module.exports = __webpack_public_path__ + "static/hero_agency-1370251850c44ab328983548f6c08427.svg";